import * as React from "react";

import ReactDOM from 'react-dom'
import SmartBanner from 'react-smartbanner';
import 'react-smartbanner/dist/main.css';

ReactDOM.render(<SmartBanner title="Liquor Connect" author="Connect Logistics Services Inc." ignoreIosVersion={true}
    appMeta={{ios: 'apple-app', android: 'google-play-app'}} />, document.getElementById('bannerContent'));